import { htmlUtils } from "cayo.ui";
import { IJsonForm, IDropdownOption } from "@cayo/shared/api/types/schema";
import { ICheckbox, IDropDown, IText, ITextField } from "../../../api/schema.api";

const azureSqlForm: IJsonForm = {
  type: "json-form",
  items: [
    {
      name: "instruction",
      type: "text",
      value: `To create a new Azure SQL database please follow ${htmlUtils.createExternalLink(
        "this guide.",
        "https://learn.microsoft.com/en-us/azure/azure-sql/database/single-database-create-quickstart?view=azuresql&tabs=azure-portal"
      )}`,
    } as IText,
    {
      pattern: "",
      isMultiline: false,
      disabled: false,
      required: true,
      placeHolder: "Enter a SQL Server name like Host\\Instance",
      label: "SQL Server name",
      tooltip: "",
      name: "server",
      type: "text-field",
      isConfidential: false,
      autoFocus: true,
    } as ITextField,
    {
      value: "Cayo.Guardian",
      pattern: "",
      isMultiline: false,
      disabled: false,
      required: false,
      placeHolder: "",
      label: "Database name",
      tooltip: "",
      name: "database",
      type: "text-field",
      isConfidential: false,
    } as ITextField,

    {
      value: true,
      label: "SQL Server authentication",
      tooltip: "",
      name: "sqlAuthentication",
      type: "checkbox",
      visible: false,
    } as ICheckbox,
    {
      pattern: "",
      isMultiline: false,
      disabled: false,
      required: true,
      placeHolder: "",
      label: "Login name",
      tooltip: "",
      name: "user",
      type: "text-field",
      isConfidential: false,
    } as ITextField,
    {
      pattern: "",
      isMultiline: false,
      disabled: false,
      required: true,
      placeHolder: "",
      label: "Password",
      tooltip: "",
      name: "password",
      type: "text-field",
      isConfidential: true,
    } as ITextField,
    {
      value: null,
      label: "Encrypt",
      name: "encrypt",
      type: "dropdown",
      required: false,
      options: [
        {
          key: "disabled",
          value: "disabled",
          text: "False",
        } as IDropdownOption,
        {
          key: "enabled",
          value: "enabled",
          text: "True",
        } as IDropdownOption,
        {
          key: "strict",
          value: "strict",
          text: "Strict",
        } as IDropdownOption,
      ],
    } as IDropDown,
    {
      value: false,
      label: "Trust Server Certificate",
      name: "trustServerCertificate",
      type: "checkbox",
      tooltip: "",
      dependsFrom: "encrypt",
      bindings: { disabled: "encrypt eq strict" },
    } as ICheckbox,
    {
      pattern: "",
      isMultiline: false,
      disabled: false,
      required: false,
      placeHolder: "Example: Connection Timeout=30",
      label: "Additional connection parameters",
      tooltip: "",
      name: "additionalParameters",
      type: "text-field",
      isConfidential: false,
    } as ITextField,
    // {
    //   value: true,
    //   label: "Restart service after the configuration is applied",
    //   tooltip: "Restart the Guardian service when the database configuration is applied.",
    //   name: "restart",
    //   type: "checkbox",
    //   visible: false,
    // } as ICheckbox,
    {
      value: true,
      label: "Copy Guardian configuration data to the new database",
      tooltip:
        "Select this option to copy managed system registrations, job configurations, saved queries, alerting rules and other configuration data. Change History, Execution History and collected events would not be copied. This Guardian Service would connect to all managed systems and start a new collection.",
      name: "copyData",
      type: "checkbox",
      visible: false,
    } as ICheckbox,
    {
      value: true,
      label: "I confirm this database is not used by another Guardian Service",
      tooltip:
        "Select this option if the target database was copied or moved from the previous installation of the Cayosoft Guardian. This Guardian Service would take the ownership over this copy of the database even if it contains information about previous owner.",
      name: "overrideOwner",
      type: "checkbox",
      visible: false,
    } as ICheckbox,
    {
      value: false,
      label: "Create the specified database if it is not present on the SQL server",
      tooltip: "",
      name: "createMissingDatabase",
      type: "checkbox",
      visible: false,
    } as ICheckbox,
  ],
  title: "Configure Database",
  submit: {
    url: "v0/settings/serviceSettings/094781f7355b4b958452716cb95380b0/cayo.graph.storageSettings/validateDatabase",
    method: "POST",
  },
};

export default azureSqlForm;
